export const PUBLIC_ADMIN_ROUTES = {
    ADMIN: '/admin',//LOGIN
}

export const PUBLIC_CLIENT_ROUTES = {
    AREA_ASSOCIADO: '/area-do-associado',
    AREA_ASSOCIADO_LOGIN: '/area-do-associado/login',
    AREA_ASSOCIADO_CADASTRO: '/area-do-associado/cadastro',

}
export const ROUTES = {
    // Rotas Públicas
    HOME: '/',
    PRODUTOS: '/produtos',
    PRODUTOS_DETAIL: '/produtos/:slug',
    BLOG: '/blog',
    BLOG_DETAIL: '/blog/:slug',
    ASSOCIADO: '/associado',
    ASSOCIADO_PACIENTE: '/associado/paciente',
    ASSOCIADO_MEDICO: '/associado/medico',
    FAQ: '/faq',
    TRANSPARENCIA: '/transparencia',
    TRANSPARENCIA_DETAIL: '/transparencia/:slug',
    AME: '/ame',


    // Rotas da Loja (Cliente)
    LOJA_LOGIN: '/loja/login',
    LOJA_HOME: '/loja',
    LOJA_BASE: '/area-do-associado/loja',
    LOJA_PRODUTOS: '/area-do-associado/loja/produtos',
    LOJA_PRODUTO_DETAIL: '/area-do-associado/loja/produtos/:slug',
    LOJA_CARRINHO: '/area-do-associado/loja/carrinho',
    LOJA_PEDIDOS: '/loja/pedidos',
    LOJA_MEUS_PEDIDOS: '/area-do-associado/loja/perfil/meus-pedidos',
    LOJA_PEDIDO_DETAIL: '/area-do-associado/loja/perfil/meus-pedidos/:id',
    LOJA_PEDIDO_PIX: '/area-do-associado/loja/perfil/meus-pedidos/:id/pix',
    LOJA_FAVORITOS: '/loja/favoritos',
    LOJA_PERFIL: '/area-do-associado/loja/perfil',
    LOJA_PRESCRICOES: '/area-do-associado/loja/perfil/prescricoes',
    LOJA_ENDERECOS: '/area-do-associado/loja/perfil/meus-enderecos',
    LOJA_MEUS_DADOS: '/area-do-associado/loja/perfil/meus-dados',
    LOJA_ALTERAR_SENHA: '/area-do-associado/loja/perfil/alterar-senha',
    ...PUBLIC_CLIENT_ROUTES,

    AREA_ASSOCIADO_VERIFICAR_EMAIL: '/area-do-associado/verificar-email',
    // Rotas do Admin
    ...PUBLIC_ADMIN_ROUTES,
    ADMIN_AUTH: '/admin/auth',
    ADMIN_DASHBOARD: '/admin/auth/dashboard',
    ADMIN_USUARIOS: '/admin/auth/usuarios',
    ADMIN_PRODUTOS: '/admin/auth/produtos',
    ADMIN_BLOG_LIST: '/admin/auth/blog',
    ADMIN_BLOG_CREATE: '/admin/auth/blog/criar',
    ADMIN_BLOG_EDIT: '/admin/auth/blog/:id/editar',
    ADMIN_FAQ_LIST: '/admin/auth/faq',
    ADMIN_FAQ_CREATE: '/admin/auth/faq/criar',
    ADMIN_FAQ_EDIT: '/admin/auth/faq/:id/editar',

    // Staff (Membros da Equipe)
    ADMIN_STAFF_LIST: '/admin/auth/equipe',
    ADMIN_STAFF_CREATE: '/admin/auth/equipe/criar',
    ADMIN_STAFF_EDIT: '/admin/auth/equipe/:id/editar',

    // Ecommerce (Categorias e Produtos)
    ADMIN_ECOMMERCE_CATEGORY_LIST: '/admin/auth/ecommerce/categorias',
    ADMIN_ECOMMERCE_CATEGORY_CREATE: '/admin/auth/ecommerce/categorias/criar',
    ADMIN_ECOMMERCE_CATEGORY_EDIT: '/admin/auth/ecommerce/categorias/:id/editar',
    ADMIN_ECOMMERCE_PRODUCT_LIST: '/admin/auth/ecommerce/produtos',
    ADMIN_ECOMMERCE_PRODUCT_CREATE: '/admin/auth/ecommerce/produtos/criar',
    ADMIN_ECOMMERCE_PRODUCT_EDIT: '/admin/auth/ecommerce/produtos/:id/editar',
    ADMIN_ECOMMERCE_SHIPPING_LIST: '/admin/auth/ecommerce/fretes',
    ADMIN_ECOMMERCE_SHIPPING_EDIT: '/admin/auth/ecommerce/fretes/:id/editar',
    ADMIN_ECOMMERCE_PRESCRIPTION_LIST: '/admin/auth/ecommerce/prescricoes',
    ADMIN_ECOMMERCE_PRESCRIPTION_DETAIL: '/admin/auth/ecommerce/prescricoes/:id',
    ADMIN_ECOMMERCE_ORDER_LIST: '/admin/auth/ecommerce/pedidos',
    ADMIN_ECOMMERCE_ORDER_DETAIL: '/admin/auth/ecommerce/pedidos/:id',

    // Clientes
    ADMIN_CLIENT_LIST: '/admin/auth/clientes',
    ADMIN_CLIENT_DETAIL: '/admin/auth/clientes/:id',

    // Relatórios
    ADMIN_REPORTS_PATIENTS: '/admin/auth/relatorios/pacientes',
    ADMIN_REPORTS_ECOMMERCE: '/admin/auth/relatorios/ecommerce',
    ADMIN_REPORTS_GENERATED: '/admin/auth/relatorios/gerados',

    // Site Settings (Configurações do Site)
    ADMIN_SITE_SETTINGS: '/admin/auth/configuracoes',

    // Logs de Auditoria
    ADMIN_AUDIT_LOG_LIST: '/admin/auth/logs',

    NOT_FOUND: '*'
};


export function formatPath(path, parms, queryParams) {
    let newPath = path
    if (parms) {
        Object.keys(parms).forEach((key) => {
            let regex = new RegExp(`:${key}\\??`)
            newPath = newPath?.replace(regex, parms[key])
        })
    }
    if (queryParams) {
        newPath += '?'
        Object.keys(queryParams).forEach((key, index) => {
            let caractere = '&'
            if (index === 0) caractere = ''
            newPath += `${caractere}${key}=${queryParams[key]}`
        })
    }

    return newPath
}